import Vue from 'vue'
import Vuex from 'vuex'
import globalStore from './global.store'

Vue.use(Vuex);

Vuex.Store.prototype.hasModule = function hasModule(pathArray) {
   let m = this._modules.root;
   return pathArray.every(p => {
      m = m._children[p];
      return m;
   });
};

const store = new Vuex.Store({
   namespaced: true,
   modules: {
      globalStore
   }
})

import { mapGetters, mapActions, mapMutations } from "vuex";
global.mapGetters = mapGetters
global.mapActions = mapActions
global.mapMutations = mapMutations

export default store;